import script from "./DemographicsAnalyticsOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemographicsAnalyticsOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./style.css?vue&type=style&index=0&id=5358bd54&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5358bd54"]])

export default __exports__